import { ApiConfigResponse } from "@/definitions/types/api/config"
import { axiosApi } from "./axiosApi"

export const getConfigApi = async (
  domain: string
): Promise<ApiConfigResponse> => {
  const response = await axiosApi.get<ApiConfigResponse>(
    `/domains/${domain}/config`
  )
  return response.data
}
